import React from 'react';
import { LuInbox, LuCircleAlert, LuRefreshCw, LuSearchX } from 'react-icons/lu';

/** Centered spinner for page/section loading. */
export const PageLoader = ({ label = 'Loading…', className = '' }) => (
  <div className={`page-loader ${className}`} role="status" aria-live="polite">
    <div className="spinner-border" aria-hidden="true" />
    <span className="visually-hidden">{label}</span>
  </div>
);

/** Rectangular shimmer placeholder. */
export const Skeleton = ({ width = '100%', height = 14, className = '', style }) => (
  <span className={`skeleton ${className}`} style={{ width, height, ...style }} aria-hidden="true" />
);

/** Stack of skeleton rows used while table-like content loads. */
export const SkeletonRows = ({ rows = 6, height = 18 }) => (
  <div className="d-grid gap-3 p-3" role="status" aria-label="Loading">
    {Array.from({ length: rows }, (_, i) => (
      <Skeleton key={i} height={height} width={`${100 - (i % 3) * 8}%`} />
    ))}
  </div>
);

export const EmptyState = ({
  title = 'No records found',
  description = 'There is nothing to show here yet.',
  icon: Icon = LuInbox,
  action,
  className = '',
}) => (
  <div className={`state-block ${className}`}>
    <span className="state-block__icon"><Icon aria-hidden="true" /></span>
    <p className="state-block__title">{title}</p>
    {description && <p className="state-block__text">{description}</p>}
    {action && <div className="state-block__actions">{action}</div>}
  </div>
);

export const NoResults = ({ query, onClear }) => (
  <EmptyState
    icon={LuSearchX}
    title="No matching records"
    description={query ? `Nothing matches “${query}”. Try a different search term.` : 'Try adjusting your search or filters.'}
    action={onClear && (
      <button type="button" className="btn btn-secondary btn-sm" onClick={onClear}>Clear search</button>
    )}
  />
);

export const ErrorState = ({
  title = 'Unable to load data',
  description = 'Something went wrong while loading this content. Please try again.',
  onRetry,
  className = '',
  page = false,
}) => (
  <div className={`state-block state-block--error ${page ? 'state-block--page' : ''} ${className}`} role="alert">
    <span className="state-block__icon"><LuCircleAlert aria-hidden="true" /></span>
    <p className="state-block__title">{title}</p>
    {description && <p className="state-block__text">{description}</p>}
    {onRetry && (
      <div className="state-block__actions">
        <button type="button" className="btn btn-secondary btn-sm" onClick={onRetry}>
          <LuRefreshCw aria-hidden="true" /> Try again
        </button>
      </div>
    )}
  </div>
);
